import styled from 'styled-components';

const RoomAirDestratificationWrapper = styled.div``;

export { RoomAirDestratificationWrapper };
